import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ConnectedHome from "./pages/ConnectedHome";
import MediaExperience from "./pages/MediaExperience";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MarketingExperience from "./pages/MarketingExperience";
import { Navigate, Link } from "react-router-dom";
import GamePromotions from "./pages/GamePromotions";
import Play from "./pages/Play";

// Scroll to top on route change, or to the #anchor when one is present
// (React Router doesn't handle hash scrolling on its own).
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a frame so the target section is mounted before scrolling.
      const id = hash.replace("#", "");
      const scroll = () => {
        const el = document.getElementById(id);
        if (el)
          el.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
              .matches
              ? "auto"
              : "smooth",
            block: "start",
          });
      };
      const t = setTimeout(scroll, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <ScrollManager />
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<ConnectedHome />} />
          <Route path="/tube" element={<MediaExperience kind="tube" />} />
          <Route path="/tunes" element={<MediaExperience kind="tunes" />} />
          {["buyers", "drivers", "pickers", "sellers", "rewards"].map(
            (page) => (
              <Route
                key={page}
                path={`/${page}`}
                element={<MarketingExperience page={page} />}
              />
            ),
          )}
          <Route
            path="/propane-exchange"
            element={<MarketingExperience page="propane" />}
          />
          <Route
            path="/kwk-swap"
            element={<Navigate replace to="/propane-exchange" />}
          />
          <Route
            path="/retailers"
            element={<Navigate replace to="/sellers" />}
          />
          <Route
            path="/exchange"
            element={<Navigate replace to="/propane-exchange#walkthrough" />}
          />
          <Route path="/play" element={<Play />} />
          <Route path="/play/:game" element={<Play />} />
          <Route path="/game-promotions" element={<GamePromotions />} />
          <Route
            path="*"
            element={
              <main id="main-content" className="mk-site mk-not-found">
                <h1>A little off route.</h1>
                <p>
                  That page isn’t here. Let’s get you back to the neighborhood.
                </p>
                <Link className="mk-button" to="/">
                  Back to KwK
                </Link>
              </main>
            }
          />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
